<template>
    <div class="page-linea-servicio page-layout">
        <!-- All Services -->
        <section-servicios />
    </div>
</template>

<script>
import SectionServicios from "@/components/layout/body-sections/section-linea-servicios.vue";

export default {
    name: 'Servicios',
    components: {
        SectionServicios
    }
}
</script>
<style lang="scss">
.bg__hero-servicios {
    // background:url('../../src/assets/images/pic-inner-proyectos-new.jpg');
    background-color: $primary-color;
    background-position: center 100%;
    background-size: cover;
    background-repeat: no-repeat;
    color:$white;
    text-align:center;
}
</style>